// Mirrors the default in defaultV2Configuration (appearance.input.placeholderTexts).
const DEFAULT_PLACEHOLDER = 'Send message';

// Entries are guarded as strings: a pre-fetched config reaches here without server-config validation.
export function activePlaceholders(prompts: readonly unknown[]): [string, ...string[]] {
  const filtered = usablePlaceholders(prompts);
  return filtered.length > 0 ? [filtered[0], ...filtered.slice(1)] : [DEFAULT_PLACEHOLDER];
}

// The same filter without the default, for a caller that has a further fallback to try.
export function usablePlaceholders(prompts: readonly unknown[]): string[] {
  return prompts.filter((prompt): prompt is string => typeof prompt === 'string' && prompt.trim().length > 0);
}
